import {
  ActionType,
  ShowToaster,
} from "../../schemas/carrierAssign/CarrierAssign.schema";
import * as Constants from "../../utils/constants";
import produce from "immer";

export const carrierAssignInitialState: ShowToaster = {
  showToaster: false,
  DriverList: [],
  assignShipmentDriverResponse: undefined,
  unAssignShipmentDriverResponse: undefined,
  shipmentForStartTrip: {},
  timestamp: "",
  loads: {},
  loadForAssignDriver: {},
  predecessorShipment: {},
  successorShipmentResponse: undefined,
  carrierIntentResponse: undefined
};

export default (state = carrierAssignInitialState, action: ActionType) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Constants.SHOW_TOASTER_VALUE:
        draft.showToaster = !draft.showToaster;
        break;
      case Constants.LOAD_DATA:
        draft.loads = action.payload;
        break;
      case Constants.ASSIGN_DRIVER_LIST:
        draft.DriverList = action.payload;
        break;
      case Constants.ADD_DRIVER_SUCCESS:
        draft.DriverList = [
          (action.payload as any).member,
          ...draft.DriverList,
        ];
        break;
      case Constants.CarrierActionTypes.ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE:
        draft.assignShipmentDriverResponse = action.payload;
        break;
      case Constants.CarrierActionTypes.UN_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE:
        draft.unAssignShipmentDriverResponse = action.payload;
        break;
      case Constants.CarrierActionTypes
        .CLEAR_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE:
        draft.assignShipmentDriverResponse = undefined;
        break;
      case Constants.CarrierActionTypes.SHIPMENT_FOR_STARTTRIP:
        draft.shipmentForStartTrip = action.payload;
        break;
      case Constants.CarrierActionTypes.SHIPMENT_FOR_STARTTRIP_TIMESTAMP:
        draft.timestamp = action.payload ? action.payload.toString() : "";
        break;
      case Constants.SET_LOAD_FOR_ASSIGN_DRIVER:
        draft.loadForAssignDriver = action.payload;
        break;
      case Constants.CarrierActionTypes.SUCCESSOR_SHIPMENT_RESPONSE:
        draft.successorShipmentResponse = action.payload;
        break;
      case Constants.CarrierActionTypes.CLEAR_SUCCESSOR_SHIPMENT_RESPONSE:
        draft.successorShipmentResponse = undefined;
        draft.assignShipmentDriverResponse = undefined;
        break;
      case Constants.CarrierActionTypes.CARRIER_INTENT_MESSAGE_RESPONSE:
        draft.carrierIntentResponse = action.payload;
        break;
      case Constants.REMOVE_DRIVER_UNASSIGNED_LOAD: {
        draft.shipmentForStartTrip = {};
        break;
      }
      case Constants.CarrierActionTypes.GET_PREDECESSOR_SHIPMENT_RESPONSE:
        draft.predecessorShipment = action.payload;
        break;
    }
  });
